import React, { useEffect, useState } from 'react';
import { Button, Textarea, ToastMessage } from '@cokitchen/cokitchen-components';
import { AddIcon } from 'cokitchen-icons';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { formatCurrency, getFullName, handleApiError } from 'utils/functions';
import FundWalletModal from '../fund-wallet-modal';
import LocalModal from 'components/base/local-modal';
import CurrencyInput from 'components/base/currency-input';
import useDashboardContext from 'contexts/dashboard.context';
import { MemberListType } from 'models/member.model';

type GiftSingleMemberProps = {
  isOpen: boolean;
  onClose: () => void;
  singlePeople?: MemberListType;
  setSinglePeople?: (value: MemberListType) => void;
  gift_type?: string;
};

const GiftSelectedMemberModal = ({
  isOpen,
  onClose,
  singlePeople,
  gift_type = 'Other'
}: GiftSingleMemberProps) => {
  const [showFundWallet, setShowFundWallet] = useState(false);
  const [note, setNote] = useState('');

  const [insufficientBalance, setInsufficientBalance] = useState(false);
  const { refetchMonthlyStat, companyWalletDetails } = useDashboardContext();
  const balance = companyWalletDetails?.available_balance;
  const [amount, setAmount] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (amount && +amount > Number(balance)) {
      setInsufficientBalance(true);
    } else {
      setInsufficientBalance(false);
    }
  }, [amount]);

  const handleFundWallet = () => {
    setShowFundWallet(true);
  };

  const GiftAMember = async () => {
    if (!singlePeople?.company_id) return;
    const data = {
      user_id: singlePeople?.user_id,
      note,
      company_id: singlePeople?.company_id,
      gift_type,
      amount
    };
    try {
      setLoading(true);
      const res = await apiService.post('gift', { data });
      if (res) {
        toast(<ToastMessage type='success' message='Member Gifted successfully' />);
        onClose();
        setAmount('');
        refetchMonthlyStat();
      }
    } catch (err) {
      handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <LocalModal title='Gift a member' isOpen={isOpen} onRequestClose={onClose}>
      <div className='w-full relative mb-[28px]'>
        <CurrencyInput
          label='How much would you like to gift'
          placeholder='50,000'
          value={amount || ''}
          onChange={(v) => setAmount(v)}
        />
      </div>
      <div className='w-full'>
        <p className='text-[#2E3031] text-sm font-medium mb-1'>Select member</p>
        <div className='border-b-[2px] border-b-[#D5D6D7] bg-[#F4F5F5] rounded-none h-[52px] text-sm flex items-center px-4  cursor-pointer'>
          {getFullName(singlePeople?.user)}
        </div>
      </div>
      <div className='w-full relative mt-4'>
        <Textarea
          design='bordered'
          value={note}
          onChange={(e) => setNote(e.target.value)}
          label='Add a note (optional)'
          placeholder='e.g great job on the presentation yesterday '
          className='font-semibold'
        />
      </div>
      <div
        className={`w-full py-3 px-4 rounded-md border flex justify-between items-center mb-2 mt-8 ${
          insufficientBalance ? 'border-[#F2F2F3]' : 'border-[#E60A2B]'
        }`}>
        <div>
          <p className='text-sm text-[#2E3031] font-medium'>Company Wallet</p>
          <p className='text-[#6F7376] text-xs'>
            Balance: {balance ? formatCurrency(balance) : ''}
          </p>
        </div>
        {insufficientBalance ? (
          <div className='rounded-[100px] bg-[#F4F1F1] py-[3px] px-[10px] text-[#E60A2B] text-xs font-medium'>
            Insufficient
          </div>
        ) : (
          <div className='w-[14px] h-[14px] bg-[#E60A2B] p-[3.8px] flex justify-center items-center rounded-full'>
            <div className='w-full h-full bg-white rounded-full'></div>
          </div>
        )}
      </div>
      {insufficientBalance && (
        <div
          onClick={handleFundWallet}
          className='cursor-pointer flex items-center gap-[2px] text-[#0080E5]'>
          <p className=' text-xs font-medium'>Fund wallet</p>
          <AddIcon className='w-4 h-4' />
        </div>
      )}
      <div className='mt-10 flex justify-end'>
        <Button
          variant='block'
          color='primary'
          disabled={!amount || insufficientBalance}
          onClick={GiftAMember}
          className='w-[139px] h-[41px] text-sm'>
          {loading ? 'Loading ...' : 'Confirm'}
        </Button>
      </div>

      {showFundWallet && (
        <FundWalletModal isOpen={showFundWallet} onClose={() => setShowFundWallet(false)} />
      )}
    </LocalModal>
  );
};

export default GiftSelectedMemberModal;
